import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react'; // Ikona dla strony 404
import './NotFoundPage.css'; // Utworzymy ten plik

function NotFoundPage() {
    return (
        <div className="not-found-container section-bg-white"> {/* Używamy kontenera na całą stronę */}
            <div className="container text-center">
                <AlertTriangle size={80} color="var(--color-accent)" strokeWidth={1} className="not-found-icon" />
                <h1>404 - Strona nie została znaleziona</h1>
                <p className="subtitle">Przepraszamy, strona, której szukasz, nie istnieje, została przeniesiona lub jest tymczasowo niedostępna.</p>
                <div className="not-found-actions">
                    <Link to="/" className="button-primary">
                        Wróć na Stronę Główną
                    </Link>
                    {/* Opcjonalnie: Link do mapy strony lub kontaktu */}
                    {/* <Link to="/kontakt" className="button-secondary" style={{marginLeft: '1rem'}}>
                        Skontaktuj się z nami
                    </Link> */}
                </div>
            </div>
        </div>
    );
}

export default NotFoundPage;